import { Drawer } from "@components";
import { Titles } from "../../variables/Titles";

import TextForm from "../types/TextForm";

export const CouponWeekForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
  onRemove,
}) => {
  const input_configs = {
    type: "number",
    prefix: "Semana ",
    suffix: "",
    precision: 0,
    min: 1,
    max: 53,
  };

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.CouponWeek}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      <TextForm
        node={node}
        input_configs={input_configs}
        onSave={(node) => onSave(node)}
        onRemove={onRemove}
      />
    </Drawer>
  );
};
